/** Thrown when GET /users/me returns 403 (account banned by admin). */
export class AccountBannedError extends Error {
  readonly status = 403;

  constructor(message = "ACCOUNT_BANNED") {
    super(message);
    this.name = "AccountBannedError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export function isAccountBannedError(e: unknown): e is AccountBannedError {
  return e instanceof AccountBannedError;
}
